import React from 'react'
import { Can } from '@morningtrain/react-auth'
import Permissions from 'services/Permissions'

export default function WhenCanHandleOrderForOffice ({ children, negate = false }) {
  return (
    <Can permission={Permissions.INVENTORY_CAN_HANDLE_OFFSET_FOR_OFFICE} negate={negate}>
      {children}
    </Can>
  )
}
